var organization_id = () => window.localStorage.getItem('selected_organization') || '';
var append = organization_id() ? `_organization_id=${organization_id()}` : '';

export default {
    append,
    organization_id,
    code: organization_id()
}
